import { configureStore } from '@reduxjs/toolkit';
import cyberReducer from 'stores/slice/cyber';
import authReducer from 'stores/slice/auth';

const store = configureStore({
  reducer: {
    cyber: cyberReducer,
    auth: authReducer,
  },
});

export default store;
